const items = [
  "Interior Painting",
  "Exterior Coatings",
  "Fine Wood Refinishing",
  "Deep Carpet & Tile Cleaning",
  "Est. 2004",
  "Fully Insured",
  "San Angelo, TX",
  "Available 24/7",
  "Free Quotes",
  "Call or Text 325-234-5947",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className="bg-red-600 text-white overflow-hidden border-y-4 border-zinc-950 py-4 select-none"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-display font-extrabold uppercase tracking-tight text-xl sm:text-2xl px-6"
              >
                {item}
                <span className="ml-12 text-zinc-950">●</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
